import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { REFRESH_API_CONFIG } from '../../tokens/refresh-api.token';

@Injectable({
  providedIn: 'any',
})
export class RefreshTokenService {
  constructor(
    private readonly httpClient: HttpClient,
    @Optional()
    @Inject(REFRESH_API_CONFIG)
    private readonly refreshApi: string
  ) {}

  getRefreshToken(): Observable<string> {
    if (!this.refreshApi) {
      throw new Error(
        'getRefreshToken requires a provider for REFRESH_API_CONFIG <string> for refreshApi url'
      );
    }

    return this.httpClient.post<string>(
      this.refreshApi,
      {},
      {
        withCredentials: true,
      }
    );
  }
}
